import { LoadingOverlay } from '@mantine/core';

import { MultilingualCodeSystems } from '@e-origin/shared';

import { useDeclarant } from '@hooks/declarant';
import { retrieveCodes } from '@hooks/retrieveCodes';
import { AsyncAutocomplete, AsyncAutocompleteProps } from './AsyncAutocomplete';
import { MultiSelect, MultiSelectProps } from './MultiSelect';

interface BaseMultiLangCodesProps {
  code: string | string[];
  system?: MultilingualCodeSystems | MultilingualCodeSystems[];
  'data-pw'?: string;
  excludeList?: string[];
  includeList?: string[];
}

type SingleSelectProps = BaseMultiLangCodesProps &
  AsyncAutocompleteProps & {
    multiple?: false;
  };

type MultiSelectModeProps = BaseMultiLangCodesProps &
  MultiSelectProps & {
    multiple: true;
  };

type MultiLangCodesProps = SingleSelectProps | MultiSelectModeProps;

export const MultiLangCodes: React.FC<MultiLangCodesProps> = (props) => {
  const { data: declarant, isLoading } = useDeclarant();
  const { code, system, 'data-pw': dataPw, multiple = false } = props;
  const { excludeList, includeList, ...restProps } = props;

  if (!declarant) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  const fetchOptions = async (search: string) => {
    const data = await retrieveCodes(code, search, declarant.language, system);
    return data.filter((d) => {
      if (includeList && !includeList.includes(d.value)) return false;
      if (excludeList?.includes(d.value)) return false;
      return true;
    });
  };

  if (multiple) {
    return <MultiSelect {...(restProps as MultiSelectProps)} fetchOptions={fetchOptions} data-pw={dataPw} />;
  }

  return <AsyncAutocomplete {...(restProps as AsyncAutocompleteProps)} fetchOptions={fetchOptions} data-pw={dataPw} />;
};
